import i18n from "Localization";
import Notifier from "../../Notifier";
import Subscriptions from "../../Subscriptions";
import DispositionCache from "../disposition/DispositionCache";
import RelationshipManager from "../relationship/Manager";
import {createJudgement, deleteJudgement} from "./services";
import {dayjsInstance, formatDate} from "../../utils/date";

export const subscriptionKeys = {
  created: "ats-judgement-created",
  updated: "ats-judgement-updated",
  deleted: "ats-judgement-deleted"
};

const MAX_EXPIRY = "2525-01-01T00:01:00.000-00:00";

const defaultJudgement = {
  confidence: "High",
  disposition: 5,
  priority: 100,
  severity: "High",
  source: "ATS Pivot Menu",
  tlp: "green",
  type: "judgement"
};

class Manager {
  constructor() {
    this.subscriptionKeys = subscriptionKeys;
  }

  createJudgement(newJudgement = {}, indicators = [], options = {}) {
    const {observable} = newJudgement,
      requestData = {...defaultJudgement},
      {notify = true} = options;

    Object.assign(requestData, newJudgement);

    const {promise, cancel} = createJudgement(requestData);

    const _promise = promise
      .then(({data}) => {
        indicators.forEach(indicator => {
          RelationshipManager.createRelationship(
            indicator.id,
            data.id,
            "relationship",
            "element-of"
          );
        });

        DispositionCache.updateObservables(observable);

        if (notify) {
          Notifier.addNotification({
            title: i18n.t("judgementManager:notifications.created"),
            text: i18n.t("judgementManager:notifications.createdMessage", {
              title: data.title
            }),
            theme: "success"
          });
        }

        Subscriptions.publish(subscriptionKeys.created, data);

        return data;
      })
      .catch(e => {
        if (notify) {
          const {response = {}} = e,
            {data = {}} = response,
            {error} = data;

          Notifier.addNotification({
            title: i18n.t("judgementManager:notifications.createError"),
            text: error || e.toString(),
            theme: "error"
          });
        }

        throw e;
      });

    return {promise: _promise, cancel};
  }

  deleteJudgement(id, options) {
    const {promise, cancel} = deleteJudgement(id),
      {notify = false} = options;

    const _promise = promise
      .then(({data}) => {
        // Delete relationships where judgement is target_ref and source_ref
        RelationshipManager.deleteRelationships({targetId: id});
        RelationshipManager.deleteRelationships({sourceId: id});

        Subscriptions.publish(subscriptionKeys.deleted, data);

        return data;
      })
      .catch(e => {
        if (notify) {
          const {response = {}} = e,
            {data = {}} = response,
            {error} = data;

          Notifier.addNotification({
            title: i18n.t("judgementManager:notifications.deleteError"),
            text: error || e.toString(),
            theme: "error"
          });
        }

        throw e;
      });

    return {promise: _promise, cancel};
  }

  /**
   * @param {any} date dayJS Obj
   * @param {String} format format: string "MM/DD/YYYY"
   * @returns {{isValid: Boolean, dateFormat: String}}
   */
  validateMaxExpiry(date) {
    return {
      isValid: date.valueOf() <= dayjsInstance(MAX_EXPIRY).valueOf(),
      dateFormat: formatDate(MAX_EXPIRY)
    };
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonJudgementManager) {
    window.atsSecurityRibbonJudgementManager = new Manager();
  }
  return window.atsSecurityRibbonJudgementManager;
};

export default Configuration();

export const ManagerClass = Manager;
